var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 4.22803C5.37321 4.22803 1.00244 7.70778 1.00244 12.0027C1.00244 16.2975 5.3704 19.7745 12.0039 19.7745C18.6373 19.7745 23.0024 16.2919 23.0024 12.0027C23.0024 7.7134 18.6317 4.22803 12.0039 4.22803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.972 14.9061C15.8609 14.5773 22.2385 13.2647 21.4515 9.6275C21.1704 8.32049 19.8269 6.88418 17.7975 5.88635C15.9616 5.09755 13.9799 4.70487 11.982 4.73392C5.82917 4.73392 1.54834 7.98882 1.54834 12.0026C1.54834 14.7965 3.62551 17.2222 6.96753 18.4365C7.66741 16.5701 10.4894 15.5077 13.972 14.9061Z",
    fill: "#007DC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0042 16.1934C9.24123 16.5391 7.97638 17.4302 7.16406 18.5123C8.7109 19.0263 10.3321 19.2809 11.9621 19.2656C18.1177 19.2656 22.3985 16.0135 22.3985 12.0025C22.3985 11.6507 22.3655 11.2997 22.3001 10.9541C22.1062 15.665 15.0343 15.8168 12.0042 16.1934Z",
    fill: "url(#paint0_linear_1447_8486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03431 8.20801H3.97119L3.99367 8.26703C4.07567 8.58905 4.10322 8.92251 4.07519 9.25362C4.07519 9.33794 4.07519 14.032 4.07519 14.032H4.11454C4.11454 14.032 5.05615 14.0657 5.93874 14.0657C7.78261 14.0657 9.0306 12.8177 9.0306 10.957C9.01936 9.28173 7.84726 8.20801 6.03431 8.20801ZM4.95777 8.728C5.07582 8.728 5.44122 8.69146 5.70263 8.69146C7.27948 8.69146 8.01309 9.45599 8.01309 11.0947C8.01309 12.7812 7.36099 13.6244 6.02025 13.6244C5.03647 13.6244 4.95777 13.5766 4.95777 12.9948V8.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5594 13.9784C14.5285 13.6354 14.5144 13.4162 14.5144 13.2054V11.1676H13.5363L13.5672 11.2322C13.6451 11.4305 13.6787 11.6435 13.6656 11.8562C13.6656 11.8703 13.6656 13.2616 13.6318 13.6017C13.3826 13.6564 13.1281 13.6837 12.8729 13.6832C11.3157 13.6832 10.5259 12.7894 10.5259 11.0298C10.5259 9.68629 11.4141 8.68284 12.6874 8.59008C13.3023 8.52604 13.9183 8.70118 14.4076 9.07916L14.4779 9.141V8.31743H14.4441C14.0023 8.22185 13.5525 8.16821 13.1006 8.15723C10.852 8.15723 9.52246 9.33495 9.52246 11.3109C9.52246 13.4134 11.1555 14.1639 12.6846 14.1639C13.2999 14.1658 13.9144 14.1207 14.5228 14.0289H14.5622L14.5594 13.9784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0584 10.8277C18.3663 10.7534 18.6409 10.5794 18.8397 10.3329C19.0385 10.0863 19.1502 9.78103 19.1575 9.46443C19.1575 8.67741 18.4463 8.20801 17.2574 8.20801H15.4922V8.2586C15.537 8.51273 15.5549 8.77088 15.5456 9.02876V14.0685H15.5878C15.5878 14.0685 16.282 14.0544 17.1337 14.0544C18.6178 14.0544 19.4694 13.4108 19.4694 12.2865C19.4807 11.5922 18.9045 11.0104 18.0584 10.8277ZM16.4366 11.1087H16.892C17.9432 11.1087 18.4772 11.5219 18.4772 12.337C18.4772 13.1522 18.0191 13.6131 17.0718 13.6131C16.6165 13.6131 16.4366 13.4473 16.4366 13.0229V11.1087ZM16.4366 8.66054H17.0128C17.9207 8.66054 18.3086 8.94162 18.3086 9.57967C18.3086 10.3105 17.8336 10.6534 16.8104 10.6534H16.4338L16.4366 8.66054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1447_8486",
    x1: 6.9139,
    y1: 15.1084,
    x2: 22.525,
    y2: 15.1084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#007DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0083CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72BF44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15.5436,
    fill: "white",
    transform: "translate(1 4.22803)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/대구-24.6c9262c6e7bef775fe72f5a58c9248f4.svg";
export { ForwardRef as ReactComponent };